import React from "react";
import { Link } from "components/common";
import ForwarderRoutes from "../../Routes";
const InputTitleCell = ({ input }) => /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.PROFILE.details(input.input_profile_id), title: input.title }, input.title);
export default InputTitleCell;
